import MdsPerSpecialization from "./MdsPerSpecialization";

export default MdsPerSpecialization;
